export default "__VITE_ASSET__ClZyLwDt__"